/**
 * Product Image Loading Fix
 * 
 * This script fixes critical image loading issues:
 * 1. Triggers lazy loading when Flickity sliders change slides
 * 2. Triggers lazy loading when Swiper sliders change slides
 * 3. Triggers lazy loading after AJAX content loads
 * 4. Ensures images load on initial page load and after DOM updates
 */

(function() {
  'use strict';

  // Wait for lazySizesT4 to be available
  function waitForLazySizes(callback) {
    if (window.lazySizesT4 && window.lazySizesT4.loader) {
      callback();
    } else {
      // Listen for lazySizesT4 to be ready
      document.addEventListener('lazysizet4s:loaded', callback);
      // Fallback: try again after a delay
      setTimeout(function() {
        if (window.lazySizesT4 && window.lazySizesT4.loader) {
          callback();
        }
      }, 1000);
    }
  }

  // Trigger lazy loading for images in a container
  function triggerLazyLoad(container) {
    if (!container) return;
    
    waitForLazySizes(function() {
      // Find all lazy-loaded images in the container
      var images = container.querySelectorAll('.lazyloadt4s:not(.lazyloadt4sed)');
      
      images.forEach(function(img) {
        // Check if image is in viewport or visible
        var rect = img.getBoundingClientRect();
        var isVisible = rect.top < window.innerHeight + 200 && 
                       rect.bottom > -200 && 
                       rect.left < window.innerWidth + 200 && 
                       rect.right > -200;
        
        if (isVisible) {
          // Trigger lazy loading
          if (window.lazySizesT4 && window.lazySizesT4.loader && window.lazySizesT4.loader.unveil) {
            window.lazySizesT4.loader.unveil(img);
          } else if (window.lazySizesT4 && window.lazySizesT4.checkElems) {
            window.lazySizesT4.checkElems();
          }
        }
      });
    });
  }

  // Fix for Flickity sliders
  function initFlickityLazyLoad() {
    // Wait for Flickity to be available
    var checkFlickity = setInterval(function() {
      var sliders = document.querySelectorAll('.flickityt4s:not([data-lazy-fix-applied])');
      
      if (sliders.length > 0 && (window.Flickity || document.querySelector('.flickityt4s-viewport'))) {
        sliders.forEach(function(slider) {
          slider.setAttribute('data-lazy-fix-applied', 'true');
          
          // Try to get Flickity instance
          var flickityInstance = slider.flickityt4s || slider.flickity;
          
          if (flickityInstance) {
            // Listen for slide changes
            flickityInstance.on('change', function(index) {
              setTimeout(function() {
                triggerLazyLoad(slider);
                // Also trigger for visible slides
                var slides = slider.querySelectorAll('.is-selected, .t4s-col-item');
                slides.forEach(function(slide) {
                  triggerLazyLoad(slide);
                });
              }, 100);
            });
            
            // Also listen for select event
            flickityInstance.on('select', function(index) {
              setTimeout(function() {
                triggerLazyLoad(slider);
              }, 100);
            });
          } else {
            // Fallback: use MutationObserver to detect slide changes
            var observer = new MutationObserver(function(mutations) {
              var hasSlideChange = mutations.some(function(mutation) {
                return Array.from(mutation.addedNodes).some(function(node) {
                  return node.nodeType === 1 && (
                    node.classList.contains('is-selected') ||
                    node.querySelector('.is-selected')
                  );
                });
              });
              
              if (hasSlideChange) {
                setTimeout(function() {
                  triggerLazyLoad(slider);
                }, 100);
              }
            });
            
            observer.observe(slider, {
              childList: true,
              subtree: true,
              attributes: true,
              attributeFilter: ['class']
            });
          }
        });
      }
    }, 500);
    
    // Stop checking after 10 seconds
    setTimeout(function() {
      clearInterval(checkFlickity);
    }, 10000);
  }

  // Fix for Swiper sliders
  function initSwiperLazyLoad() {
    var swiperContainers = document.querySelectorAll('.swiper:not([data-lazy-fix-applied])');
    
    swiperContainers.forEach(function(container) {
      container.setAttribute('data-lazy-fix-applied', 'true');
      
      // Check if Swiper is initialized
      if (container.swiper) {
        var swiper = container.swiper;
        
        // Listen for slide changes
        swiper.on('slideChange', function() {
          setTimeout(function() {
            triggerLazyLoad(container);
            // Trigger for active slide
            var activeSlide = container.querySelector('.swiper-slide-active');
            if (activeSlide) {
              triggerLazyLoad(activeSlide);
            }
          }, 100);
        });
        
        swiper.on('slideChangeTransitionEnd', function() {
          setTimeout(function() {
            triggerLazyLoad(container);
          }, 100);
        });
      } else {
        // Wait for Swiper to initialize
        var checkSwiper = setInterval(function() {
          if (container.swiper) {
            clearInterval(checkSwiper);
            var swiper = container.swiper;
            
            swiper.on('slideChange', function() {
              setTimeout(function() {
                triggerLazyLoad(container);
              }, 100);
            });
            
            swiper.on('slideChangeTransitionEnd', function() {
              setTimeout(function() {
                triggerLazyLoad(container);
              }, 100);
            });
          }
        }, 100);
        
        // Stop checking after 5 seconds
        setTimeout(function() {
          clearInterval(checkSwiper);
        }, 5000);
      }
    });
  }

  // Fix for AJAX-loaded content
  function initAjaxLazyLoad() {
    // Observe DOM changes for AJAX content
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            // Check if it's a product container or collection content
            if (node.classList && (
              node.classList.contains('t4s-product') ||
              node.classList.contains('t4s-products') ||
              node.classList.contains('t4s-col-item') ||
              node.querySelector('.t4s-product') ||
              node.querySelector('.lazyloadt4s')
            )) {
              setTimeout(function() {
                triggerLazyLoad(node);
                // Also force load images directly as fallback
                forceLoadImages(node);
              }, 200);
            }
            
            // Check for data-contentlm-replace (load more content)
            if (node.hasAttribute && node.hasAttribute('data-contentlm-replace')) {
              setTimeout(function() {
                triggerLazyLoad(node);
                forceLoadImages(node);
              }, 300);
            }
          }
        });
      });
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Force load images directly if lazy loading fails (fallback mechanism)
  function forceLoadImages(container) {
    if (!container) container = document.body;
    
    var images = container.querySelectorAll('img.lazyloadt4s:not(.lazyloadt4sed)');
    
    images.forEach(function(img) {
      var dataSrc = img.getAttribute('data-src');
      var currentSrc = img.src;
      
      // Check if image has a valid data-src but src is still placeholder
      if (dataSrc && (
        currentSrc.indexOf('data:image/gif') === 0 ||
        currentSrc.indexOf('width=1') > -1 ||
        currentSrc.indexOf('_1x1.') > -1 ||
        !img.complete ||
        img.naturalWidth === 0
      )) {
        // Build proper image URL from data-src
        var imageUrl = dataSrc;
        
        // If data-src has width=1, replace with a reasonable size
        if (imageUrl.indexOf('width=1') > -1) {
          imageUrl = imageUrl.replace('width=1', 'width=600');
        } else if (imageUrl.indexOf('_1x1.') > -1) {
          imageUrl = imageUrl.replace('_1x1.', '_600x600.');
        }
        
        // Set src directly as fallback
        if (imageUrl && imageUrl !== currentSrc) {
          img.src = imageUrl;
          img.classList.add('lazyloadt4sed');
          img.classList.remove('lazyloadt4s');
        }
      }
    });
  }

  // Initialize all fixes
  function init() {
    // Initialize Flickity lazy load
    initFlickityLazyLoad();
    
    // Initialize Swiper lazy load
    initSwiperLazyLoad();
    
    // Initialize AJAX lazy load
    initAjaxLazyLoad();
    
    // Trigger initial check for visible images
    waitForLazySizes(function() {
      setTimeout(function() {
        if (window.lazySizesT4 && window.lazySizesT4.checkElems) {
          window.lazySizesT4.checkElems();
        }
        // Force load images on collection pages as fallback
        if (document.body.classList.contains('template-collection') || 
            document.querySelector('.t4s-main-collection-page') ||
            window.location.pathname.indexOf('/collections/') > -1) {
          setTimeout(function() {
            forceLoadImages();
          }, 1000);
        }
      }, 500);
    });
    
    // Also force load images immediately on collection pages
    if (document.body.classList.contains('template-collection') || 
        document.querySelector('.t4s-main-collection-page') ||
        window.location.pathname.indexOf('/collections/') > -1) {
      setTimeout(function() {
        forceLoadImages();
      }, 1500);
    }
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize on section load (Shopify theme editor)
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function() {
      setTimeout(init, 100);
    });
  }

  // Re-initialize on AJAX content load
  document.addEventListener('lazyincludeloaded', function() {
    setTimeout(function() {
      init();
      forceLoadImages();
    }, 200);
  });

  // Also listen for custom events that might indicate content updates
  document.addEventListener('t4s:content:updated', function() {
    setTimeout(function() {
      init();
      forceLoadImages();
    }, 200);
  });

  // Listen for collection page AJAX updates
  document.addEventListener('DOMContentLoaded', function() {
    // Watch for collection page product grid updates
    var collectionContainer = document.querySelector('[data-ntajax-container]');
    if (collectionContainer) {
      var collectionObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.addedNodes.length > 0) {
            setTimeout(function() {
              forceLoadImages(collectionContainer);
              triggerLazyLoad(collectionContainer);
            }, 300);
          }
        });
      });
      
      collectionObserver.observe(collectionContainer, {
        childList: true,
        subtree: true
      });
    }
  });

})();

